import React from "react"
//************************************//
import { _hasAnyAbility } from '@src/utility/context/Can'
import FieldsDetail from './fields-detail'
//************************************//
const CustomFields = ({title}) => {
  return (
		<div className={'pb-1'}>
			<div className={'d-flex justify-content-between align-items-center mb-2 bg-light py-1 px-2 border-bottom'}>
				<h4 className={'m-0'}>{title}</h4>
			</div>
			<div className="px-2">
				<FieldsDetail/>
			</div>
		</div>
  )
}
export default CustomFields
